import { Checkbox, FormControlLabel } from '@mui/material'
import { FC } from 'react'

/**
 * "Internal use only (hide from member)" checkbox shared by the care plan
 * create/edit modals. When checked, the care plan is hidden from the member
 * (`visible_to_patient: false`). Callers own their own layout wrapper.
 */
export const InternalUseOnlyCheckbox: FC<{
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}> = ({ checked, onChange, disabled }) => (
  <FormControlLabel
    control={
      <Checkbox checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} />
    }
    label="Internal use only (hide from member)"
  />
)
